import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ApiUrlService } from '../core/api-url';
import { RegistrationAnswer } from './registration-form.models';

export interface CreateCheckoutSessionRequest {
  paymentType: string;
  agreementAccepted: true;
  agreementAcceptanceId: string;
  tenantId?: string;
  tenantSlug?: string;
  formRevision: number;
  answers: RegistrationAnswer[];
  /** Team: logged-in captain id (optional). */
  captainUserId?: string;
  /** Individual: logged-in player user id (optional). */
  playerUserId?: string;
  teamData?: {
    teamName: string;
    divisionId: string;
    divisionName: string;
    season: string;
    seasonId: string;
    previousDivision: string;
    jerseyQuantity: number;
  };
  captainData?: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    dateOfBirth: Date;
    address: {
      addressLine1: string;
      addressLine2: string;
      city: string;
      state: string;
      zipCode: string;
      country: string;
    };
  };
  playerData?: {
    fName: string;
    lName: string;
    email: string;
    phone: string;
    jersey: number;
    size: string;
    gender: string;
    previousDivision: string;
    desiredDivisionId: string;
    desiredDivisionName: string;
  };
  seasonId?: string;
  merchandisePackage?: string;
  jerseyQuantity?: number;
}

export interface CreateCheckoutSessionResponse {
  clientSecret: string;
  sessionId?: string;
  paymentId?: string;
}

export interface SessionStatusResponse {
  status: string;
  payment_status: string;
  amount_total: number;
  registration_status: 'processing' | 'complete';
  flow: string;
  registration_type?: 'team' | 'player';
  team_id?: string;
  season_id?: string;
  team_name?: string;
  season_name?: string;
  division_name?: string;
  payment_type?: string;
  jersey_quantity?: number;
  return_to?: 'dashboard' | 'team_payments';
  payment_id?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  constructor(private http: HttpClient, private apiUrl: ApiUrlService) {}

  createCheckoutSession(request: CreateCheckoutSessionRequest): Promise<CreateCheckoutSessionResponse> {
    return firstValueFrom(
      this.http.post<CreateCheckoutSessionResponse>(
        this.apiUrl.url('/payments/create-checkout-session'),
        request
      )
    );
  }

  getSessionStatus(sessionId: string): Promise<SessionStatusResponse> {
    return firstValueFrom(
      this.http.get<SessionStatusResponse>(
        this.apiUrl.url(`/payments/session-status/${sessionId}`)
      )
    );
  }
}

